export default {
  home: "Главная",
  catalog: "Каталог",
  news: "Новости",
  about: "О проекте",
  contacts: "Контакты",
  writers: "Писатели",
  events: "Мероприятия",
  deposits: "Депонирование",
  account: "Кабинет",
  cabinet: "Личный кабинет",
  admin: "Админка",
  login: "Войти",
  loginMobile: "Войти",
  logout: "Выйти",
  openMenu: "Открыть меню",
  closeMenu: "Закрыть меню",
  mainNav: "Основная навигация",
  notifications: "Уведомления",
  partnerAilaAlt: "AILA",
  ailaEcosystemAria: "AILA, экосистема РГБ",
  portal: {
    events: "Мои мероприятия",
    deposits: "Мои депозиты",
    createEvent: "Создать мероприятие",
    moderateEvents: "Модерация мероприятий",
    moderateDeposits: "Модерация депозитов",
    registrations: "Мои регистрации",
    applyDeposit: "Подать заявку",
  },
}
